export { createTSPlugin } from './typescript'
